import {
  UserCheck, Globe2, Route, FileCheck2, MessagesSquare, BookOpenCheck, MapPinned,
  GraduationCap, FileText, FolderCheck, Award, Stamp, Plane, HeartHandshake, Compass,
  ShieldCheck, Heart, Eye, Sparkles, ArrowRight, ArrowUpRight, Menu, X, ChevronDown,
  MapPin, Calendar, Quote, Search, Building2, CheckCircle2, Loader2, Phone, Mail, Clock,
  Send, Landmark, Handshake, Users, Target, Binoculars, ListChecks,
  BadgePercent, HandCoins, BellRing, SearchCheck,
  Instagram, Facebook, Linkedin, Star, Youtube,
} from "lucide-react";

const MAP = {
  UserCheck, Globe2, Route, FileCheck2, MessagesSquare, BookOpenCheck, MapPinned,
  GraduationCap, FileText, FolderCheck, Award, Stamp, Plane, HeartHandshake, Compass,
  ShieldCheck, Heart, Eye, Sparkles, ArrowRight, ArrowUpRight, Menu, X, ChevronDown,
  MapPin, Calendar, Quote, Search, Building2, CheckCircle2, Loader2, Phone, Mail, Clock,
  Send, Landmark, Handshake, Users, Target, Binoculars, ListChecks,
  BadgePercent, HandCoins, BellRing, SearchCheck,
  Instagram, Facebook, Linkedin, Star, Youtube,
};

export default function Icon({ name, className = "h-5 w-5", strokeWidth = 1.75 }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
